declare global {
  interface Window {
    _DATADOG_SYNTHETICS_BROWSER: boolean;
  }
}

// From Datadog Docs: https://docs.datadoghq.com/synthetics/guide/identify_synthetics_bots/?tab=singleandmultistepapitests#browser-variables
const isSyntheticTest = () => typeof window !== 'undefined' && window?._DATADOG_SYNTHETICS_BROWSER !== undefined;

export default isSyntheticTest;
